// القاعدة الذهبية: كل الأرقام في التطبيق تُعرض بأرقام لاتينية + فواصل آلاف (,).
// يُمنع منعاً باتاً عرض قيمة مالية أو كمية بلا `fmtMoney` / `fmtQty` / `fmtPct`.
import { localeFor } from "./calendar";

const LATIN = "-u-nu-latn";

// نظام التقويم الفعّال في التطبيق (يُضبط من فرع المستخدم عبر CalendarSync).
let _cal = "greg_intl";
export const setActiveCalendar = (system) => {
  _cal = system || "greg_intl";
};
export const activeCalendar = () => _cal;

export const localeOf = (lang) => (lang === "ar" ? `ar-AE${LATIN}` : "en-GB");

export const formatTime = (iso, lang = "en") =>
  iso ? new Date(iso).toLocaleTimeString(localeOf(lang), { hour: "2-digit", minute: "2-digit", hour12: false }) : "—";

export const formatDate = (value, lang = "en", options = { weekday: "long", day: "numeric", month: "short" }) =>
  value ? new Date(value).toLocaleDateString(localeFor(_cal, lang), options) : "—";

export const formatNumber = (value, lang = "en", options = {}) =>
  value === null || value === undefined || value === "" ? "—" : Number(value).toLocaleString(localeOf(lang), options);

const toNum = (v) => {
  if (v === null || v === undefined || v === "") return NaN;
  const n = Number(v);
  return Number.isFinite(n) ? n : NaN;
};

// مالية: منزلتان لو فيه كسر، وإلا صحيح — كلاهما بفواصل آلاف.
// مثال: 15500 → "15,500" ، 15500.5 → "15,500.50" ، 1550.99 → "1,550.99".
export const fmtMoney = (value) => {
  const n = toNum(value);
  if (Number.isNaN(n)) return "0";
  const hasFraction = Math.abs(n - Math.trunc(n)) > 1e-9;
  return n.toLocaleString("en-GB", {
    minimumFractionDigits: hasFraction ? 2 : 0,
    maximumFractionDigits: 2,
  });
};

// كمية: حتى 3 منازل + فواصل آلاف. مثال: 1550 → "1,550" ، 1.5 → "1.5".
export const fmtQty = (value) => {
  const n = toNum(value);
  if (Number.isNaN(n)) return "0";
  return n.toLocaleString("en-GB", { maximumFractionDigits: 3 });
};

// نسبة مئوية: حتى منزلتين + فواصل آلاف (بدون علامة %).
export const fmtPct = (value, digits = 2) => {
  const n = toNum(value);
  if (Number.isNaN(n)) return "0";
  return n.toLocaleString("en-GB", { maximumFractionDigits: digits });
};

// عدد صحيح مع فواصل آلاف. مثال: 12345 → "12,345".
export const fmtInt = (value) => {
  const n = toNum(value);
  if (Number.isNaN(n)) return "0";
  return n.toLocaleString("en-GB", { maximumFractionDigits: 0 });
};
